export default {
  title: "Participation application",
  send: "Send",
  sent: "Sent",

  inviteAlreadySent:
    "The participant code of the exhibition has already been sent to {0}.",
  resendInvite: "Resend participant code",
  inviteResentSuccessMessage:
    "Your participant code for the {0} exhibition has been sent to {1}. <br /><br /> Check your inbox.",

  modal: {
    contactPersonTitle: "Contact person details",
    companyDetailsTitle: "Company details",
    eventDetailsTitle: "Details for exhibition",

    areaFieldTitle: "Required area",
    areaFieldSqMeters: "m<sup>2</sup>",

    areaTypeFieldTitle: "Area type",
    areaTypeEquipped: "Equipped",
    areaTypeNotEquipped: "Unequipped",

    subjectFieldTitle: "Thematic section"
  }
};
